function CallToAction() {
    const watchMobileWidth = window.matchMedia("(max-width: 640px)")
    const watchTabletWidth = window.matchMedia("(max-width: 1280px)")
    const watchPrefersMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

    const homeSubscribeSection = document.querySelector('.home-subscribe')
    const homeSubscribeFormArea = document.querySelector('.home-subscribe__content')
    const homeSubscribeImage = document.querySelector('.home-subscribe__background-image')

    if (homeSubscribeSection) {
        if (!watchMobileWidth.matches && !watchTabletWidth.matches && !watchPrefersMotion.matches) {
            gsap.to(homeSubscribeFormArea, {
                scrollTrigger: {
                    trigger: homeSubscribeSection,
                    start: "top 80%",
                    end: "bottom 0px",
                    scrub: 0.75
                },
                y: 290
            })
            
            gsap.to(homeSubscribeImage, {
                scrollTrigger: {
                    trigger: homeSubscribeSection,
                    start: "top 60%",
                    end: "bottom 20px",
                    scrub: 0.75
                },
                right: '400px'
            })
        }
    }
}

export default CallToAction